import { apiBaseUrl } from './constants'

// const paymentStatus = { 'status': 'Success', 'data': { 'type': 'Zakah', 'terminal_id': 1, 'status': 'CREATED', 'ps_response': null, 'ps_reference': null, 'id': 11, 'amout': 500 } }

function getHeaders () {
  return new Headers({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('user-store-token')}`
  })
}

export default {
  requestPayment ({ type, amount, terminalId }) {
    return fetch(`${apiBaseUrl}/user/donation`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({
        status: 'Created',
        type,
        amount,
        terminal_id: terminalId
      })
    })
    .then(response => response.json())
    .then(response => response)
  },
  updatePaymentRequest ({ donationId, status, ps_reference, ps_response }) {
    return fetch(`${apiBaseUrl}/user/donation/${donationId}`, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify({
        id: donationId,
        status,
        ps_reference,
        ps_response
      })
    }).then((response) => {
      return response.json().data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/donations.js